import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { RequestDeviceWarehouseRefillsService } from "../../../services/request-device-warehouse-refills.service";
import { RequestDeviceWarehouseRefillDto } from "../../../models/request/request-device-warehouse-refills";

@Component({
    selector: 'confirm-collision',
    templateUrl: './confirm-collision.component.html',
    styleUrls: ['./confirm-collision.component.scss',
        '../../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
        '../../../../../vendor/libs/angular2-ladda/angular2-ladda.scss']
})
export class ConfirmCollisionComponent implements OnInit {
    
    @Input() requestId: number;
    @Input() activityId: number;

    @Output() onCancelEvent: EventEmitter<any> = new EventEmitter<any>();
    @Output() onContinueEvent: EventEmitter<any> = new EventEmitter<any>();

    items: RequestDeviceWarehouseRefillDto[] = [];

    loading: boolean = false;

    constructor(
        private requestDeviceWarehouseRefillsService: RequestDeviceWarehouseRefillsService
    ) { }
    
    ngOnInit(): void {
        this.loading = true;
        this.requestDeviceWarehouseRefillsService.getRequestDeviceWarehouseRefillsWithParts(this.requestId).subscribe(resp => {
            this.items = resp.data;
            this.loading = false;
        });
    }

    cancel() {
        this.onCancelEvent.emit();
    }

    reject() {
        this.loading = true;
        this.requestDeviceWarehouseRefillsService.rejectCollision({requestId: this.requestId, activityId: this.activityId}).subscribe((resp) => {
            if (resp.isSuccessful) {
                this.onContinueEvent.emit();
            }
            this.loading = false;
        }, () => this.loading = false);
    }

    confirm() {
        this.loading = true;
        this.requestDeviceWarehouseRefillsService.confirmCollision({requestId: this.requestId, activityId: this.activityId}).subscribe((resp) => {
            if (resp.isSuccessful) {
                this.onContinueEvent.emit();
            }
            this.loading = false;
        }, () => this.loading = false);
    }
}